<template>
  <div class="input">
    <label v-if="label">{{label}}</label>
    <input 
      type="file" 
      id="file" 
      ref="file" 
      v-on:change="handleFileUpload()"
      v-on="listeners"
      v-bind="$attrs"
      />
  </div>
</template>

<script>
export default {
  props: ["label", "base64"],
  methods: {
    handleFileUpload() {
      if (this.base64) {
        var reader = new FileReader();
        reader.readAsDataURL(this.$refs.file.files[0]);
        reader.onload = () => {
          this.$emit("upload", reader.result);
        };
      } else {
        let file = this.$refs.file.files[0];
        this.$emit("upload", file);
      }
    }
  },
  computed: {
    listeners() {
      let { input, ...listeners } = this.$listeners;
      return listeners;
    }
  }
};
</script>

<style>

</style>
